import { Tabs as AntTabs, type TabsProps } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';

const StyledTabs = styled(AntTabs)`
  .ant-tabs-nav {
    padding: 0 28px;
  }

  .ant-tabs-nav:before {
    border-bottom: none;
  }
`;

interface Props {
  tabs: TabsProps['items'];
  defaultKey: string;
}

export const LeaveApplicationTabs: React.FC<Props> = ({ tabs, defaultKey }) => {
  const [currentTab, setTab] = useState(defaultKey);

  const handleChangeTab = (key: string) => {
    setTab(key);
  };

  // Browser page translation replaces text nodes with <font> wrappers, so toggling a bare text label
  // makes React remove a node that is no longer in the DOM. Wrapping it means React removes the <span> instead
  const items = tabs?.map((tab) => ({ ...tab, label: tab.label && <span>{tab.label}</span> }));

  return (
    <StyledTabs defaultActiveKey={currentTab} items={items} onChange={handleChangeTab} />
  );
};
